import apiService from "./../../../../server";
import {
  ORG_EXTERNAL_CONTACTS,
  ORG_EXTERNAL_PARAM_FIELDS,
  ORG_EXTERNAL_SUBSCRIBERS,
  ORG_EXTERNAL_TEMPLATES,
  ORG_EXTERNAL_VENDOR_TEMPLATES,
} from "../api";

export function fetchExternalContacts() {
  return apiService.get(ORG_EXTERNAL_CONTACTS);
}

export function createExternalContact(data: {
  name: string;
  mobileNumber: string;
  active?: boolean;
}) {
  return apiService.post(ORG_EXTERNAL_CONTACTS, data);
}

export function updateExternalContact(data: {
  id: string;
  name: string;
  mobileNumber: string;
  active?: boolean;
}) {
  return apiService.put(ORG_EXTERNAL_CONTACTS, data);
}

export function deleteExternalContact(id: string) {
  return apiService.delete(ORG_EXTERNAL_CONTACTS, { params: { id } });
}

export function fetchExternalTemplates() {
  return apiService.get(ORG_EXTERNAL_TEMPLATES);
}

export function fetchVendorWhatsappTemplates() {
  return apiService.get(ORG_EXTERNAL_VENDOR_TEMPLATES);
}

export function createExternalTemplate(data: object) {
  return apiService.post(ORG_EXTERNAL_TEMPLATES, data);
}

export function updateExternalTemplate(data: object) {
  return apiService.put(ORG_EXTERNAL_TEMPLATES, data);
}

export function deleteExternalTemplate(id: string) {
  return apiService.delete(ORG_EXTERNAL_TEMPLATES, { params: { id } });
}

export function fetchExternalParamFields() {
  return apiService.get(ORG_EXTERNAL_PARAM_FIELDS);
}

export function fetchTaskExternalSubscribers(taskCode: string) {
  return apiService.get(ORG_EXTERNAL_SUBSCRIBERS, { params: { taskCode } });
}

export function saveTaskExternalSubscribers(taskCode: string, contactIds: string[]) {
  return apiService.put(ORG_EXTERNAL_SUBSCRIBERS, { contactIds }, { params: { taskCode } });
}
